import { render, staticRenderFns } from "./ModalRecebimentoFiltro.vue?vue&type=template&id=4813e928&scoped=true"
import script from "./ModalRecebimentoFiltro.vue?vue&type=script&lang=ts"
export * from "./ModalRecebimentoFiltro.vue?vue&type=script&lang=ts"
import style0 from "./ModalRecebimentoFiltro.vue?vue&type=style&index=0&id=4813e928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4813e928",
  null
  
)

export default component.exports